<template>
  <div>
    <div class="search-flex">
      <!-- 搜索框 -->
      <div>
        <el-input class="search_input" clearable placeholder="激活码名称" size="small"
          v-model="searchParams.cdkeyName"></el-input>
        <el-select class="search_input" clearable placeholder="激活码会员" size="small" v-model="searchParams.cdkeyMemberId">
          <el-option v-for="item in cdkeyMemberList.value" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <!-- 商品状态 -->
        <el-select class="search_input" clearable placeholder="状态" size="small" v-model="searchParams.status">
          <el-option label="生效" value="1"> </el-option>
          <el-option label="失效" value="0"> </el-option>
        </el-select>
      </div>
      <div>
        <!-- 搜索按钮 -->
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_SEARCH'" type="primary" size="small" @click="search">搜索</el-button>
        <!-- 新增按钮 -->
        <el-button v-auth="'ACTIVE_GOODS_MANAGE_ADD'" size="small" @click="add">新增</el-button>
      </div>
    </div>
    <AddDialog ref="addDialog"></AddDialog>
  </div>
</template>

<script>
import AddDialog from "./Add.vue";
import Message from '@/components/Message'

export default {
  inject: ["searchParams", "getList", "cdkeyMemberList", "unionGoodsList"],
  provide() {
    return {
      cdkeyMemberList: this.cdkeyMemberList,
      unionGoodsList: this.unionGoodsList,
      getList: this.getList,
    };
  },
  name: "WebSaaSSearch",
  components: {
    AddDialog,
  },

  data() {
    return {

    };
  },

  methods: {
    /** 搜索 */
    search() {
      console.log("搜索", this.searchParams);
      /** 搜索时把当前页置为第一页 */
      this.searchParams.current = 1;
      this.getList();
      Message.success("搜索成功");
    },
    /** 新增 */
    add() {
      this.$refs.addDialog.show();
    },

  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}

::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
}
</style>